module.exports = __webpack_public_path__ + "img/app_store_score.875136da.jpg";